import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import AkIconQuestionCircle from '@atlaskit/icon/glyph/question-circle';
import Immutable from 'immutable';
import React from 'react';

import * as analytics from 'common/utils/analytics/analytics';
import {
  customerDropdownItems,
  developerDropdownItems,
  helpItems,
} from '../../../../constants/dropdownGroups';

const HelpDropdown = () => {
  const onItemActivate = menuItem => {
    analytics.trackHelpActionClicked(menuItem.content);
    if (menuItem.onActivate) {
      menuItem.onActivate();
    }
  };

  const renderDropdownItems = items => {
    return items.map(item => (
      <DropdownItem
        key={item.content}
        href={item.href}
        target={item.target ?? '_blank'}
        onClick={() => onItemActivate(item)}
      >
        {item.content}
      </DropdownItem>
    ));
  };

  const renderDropdownItemGroups = itemGroups => {
    return itemGroups.map((itemGroup, index) => (
      <DropdownItemGroup key={index} title={itemGroup.heading}>
        {renderDropdownItems(itemGroup.items)}
      </DropdownItemGroup>
    ));
  };

  const items = Immutable.OrderedSet([
    developerDropdownItems.set('heading', 'Developers'),
    customerDropdownItems.set('heading', 'Customers'),
    helpItems,
  ]);

  return (
    <div className="help-menu">
      <DropdownMenu
        appearance="tall"
        position="bottom right"
        trigger={
          <a className="help-dropdown-trigger">
            <div className="question-icon">
              <AkIconQuestionCircle label="Help" secondaryColor="inherit" size="medium" />
            </div>
            <span>Help</span>
          </a>
        }
      >
        {renderDropdownItemGroups(items.toJS())}
      </DropdownMenu>
    </div>
  );
};

export default HelpDropdown;
